import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-arrow_left",
  "use": "rt-portal-arrow_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-arrow_left\">\r\n<path d=\"M750,217.5V140c0-6.7-7.7-10.4-12.9-6.3L286.3,486.8c-16.4,12.8-16.4,37.6,0,50.4l450.8,353.1c5.3,4.1,12.9,0.4,12.9-6.3\r\n\tv-77.5c0-4.9-2.3-9.6-6.1-12.6L383.9,512l360-281.9C747.7,227.2,750,222.5,750,217.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/arrow_left.svg
// module id = 1794
// module chunks = 228